/** Legacy slide URLs are displayed by the persistent LearnDeckHost in the Learn layout. */
export function SlideLessonPage(_props: { slideSlug: string }) {
  // eslint-disable-next-line han-page-components/no-blank-page -- History-only leaf; LearnLayout renders the persistent, visible LearnDeckHost for this route.
  return null;
}
